"use strict";
/**
 * @author Maxim Seredkin
 */
export default [
  "$resource",
  function ($resource) {
    return $resource("api/invest-register", null, {
      getAll: { url: "api/invest-register", method: "GET" },
    });
  },
];
